import PortalIdParser from 'PortalIdParser';
import UILink from 'UIComponents/link/UILink';
import useFetchSmsCrmObject from './hooks/useFetchSmsCrmObject';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AutomatedSmsName({
  rootMicId,
  use
}) {
  const {
    smsCrmObject
  } = useFetchSmsCrmObject({
    rootMicId
  });
  if (!smsCrmObject) return null;
  const {
    hs_name,
    hs_content_id
  } = smsCrmObject.properties;
  if (use === 'link') {
    return /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: `/sms/${PortalIdParser.get()}/details/${hs_content_id.value}/performance`,
      children: hs_name.value
    });
  }
  return hs_name.value;
}